import React, { Component } from 'react';
import UserView from './UserTreeView/UserView'
import AddUser from "./UserAdd/AddUser";
import Roles from "./UserRoles/Roles";
import Assignment from "./UserAssignment/Assignment";
import UpdatePassword from "./UserPassword/UpdatePassword";
import UserTabs from "./UserTabs";
import axios from "axios";
import MetaTags from 'react-meta-tags';
import Favicon from 'react-favicon'
import UserInfo from "./UserInfo/UserInfo";
import ConsoleHelper from "./ConsoleHelper";

const textForStorage = 'Hello World.'


export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {
                ConsoleHelper("DashBoard page with username as %s with session id as %s ",response.data , sessionStorage.getItem('COOKIE'));
                this.setState({ loggedInUser: response.data })
                // setter
                sessionStorage.setItem('loggedUserStorage', response.data);
                ConsoleHelper(sessionStorage.getItem("loggedUserStorage"),"=== LOG_1 === Inside componentDidMount %s with data ","Dashboard",this.state.loggedInUser);
            }).finally(()=> {
            // this.hideLoader();
        })
            .catch(error => {
                ConsoleHelper("GOT ERROR HERE for Get LoggedIn User",error);
            });
    }


    render() {
        return <div className="main-content">
            <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
            <MetaTags>
                <title>DataStream Version 2.0</title>
                <meta name="description" content="Some description." />
            </MetaTags>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">User Management</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">User
                                            Management</a></li>
                                        <li className="breadcrumb-item active">User Info</li>
                                    </ol>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-9">
                            <div className="card">
                                <div className="card-body">
                                   <UserTabs data={this.state}/>
                                    <div className="tab-content p-3 text-muted">
                                        <UserInfo data={this.state}/>
                                        <AddUser data={this.state}/>
                                        <Roles data={this.state}/>
                                        <Assignment data={this.state} />
                                        <UpdatePassword data={this.state}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <UserView onUpdate={this.onUpdate.bind(this)}/>
                    </div>
                </div>
            </div>
        </div>;

        }

        //Function to update state from userView
    onUpdate (data) { this.setState({ data }) }
    }